import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Loader2, ChevronLeft, ChevronRight, FileText } from "lucide-react";
import { toast } from "sonner";

// Fit-to-screen viewer for payment proofs / receipts. items: [{ url, label, content_type }]
export default function AttachmentViewer({ items, start = 0, title = "Attachment", onClose }) {
  const [i, setI] = useState(start);
  const [url, setUrl] = useState(null);
  const it = items[i];
  useEffect(() => {
    let u; setUrl(null);
    if (!it) return;
    if (it.src) { setUrl(it.src); return; } // direct URL (e.g. GIF) — no auth blob fetch
    api.get(it.url, { responseType: "blob" }).then((r) => { u = URL.createObjectURL(r.data); setUrl(u); }).catch(() => toast.error("Could not load attachment"));
    return () => { if (u) URL.revokeObjectURL(u); };
  }, [it?.url, it?.src]); // eslint-disable-line
  if (!it) return null;
  const isPdf = (it.content_type || "").includes("pdf");
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-4xl border-0 bg-black/95 p-0 text-white" data-testid="attachment-viewer">
        <DialogHeader className="px-4 pt-3"><DialogTitle className="text-sm font-600 text-white/90">{title}{items.length > 1 ? ` · ${i + 1} of ${items.length}` : ""}{it.label ? ` — ${it.label}` : ""}</DialogTitle></DialogHeader>
        <div className="relative flex h-[78vh] w-full items-center justify-center overflow-hidden">
          {!url ? <Loader2 className="h-7 w-7 animate-spin" /> : isPdf ? <iframe title={title} src={url} className="h-full w-full bg-white" /> : <img src={url} alt={it.label || title} className="max-h-full max-w-full object-contain" data-testid="attachment-image" />}
          {items.length > 1 && <>
            <Button size="icon" variant="ghost" className="absolute left-2 top-1/2 -translate-y-1/2 rounded-full bg-black/50 text-white hover:bg-black/70" onClick={() => setI((i - 1 + items.length) % items.length)} data-testid="attachment-prev"><ChevronLeft /></Button>
            <Button size="icon" variant="ghost" className="absolute right-2 top-1/2 -translate-y-1/2 rounded-full bg-black/50 text-white hover:bg-black/70" onClick={() => setI((i + 1) % items.length)} data-testid="attachment-next"><ChevronRight /></Button>
          </>}
        </div>
        {items.length > 1 && <div className="flex gap-2 overflow-x-auto px-4 pb-3">{items.map((x, k) => <button key={x.url || x.src || k} onClick={() => setI(k)} className={`flex h-12 w-12 shrink-0 items-center justify-center rounded border ${k === i ? "border-[hsl(var(--gold))]" : "border-white/20"} bg-white/10 text-[0.6rem]`} data-testid={`attachment-thumb-${k}`}>{(x.content_type || "").includes("pdf") ? <FileText className="h-5 w-5" /> : k + 1}</button>)}</div>}
      </DialogContent>
    </Dialog>
  );
}
